import $ from 'jquery'
import swiper from './components/swiper'
import termDefinition from './components/term-definition'

import Accordion from './components/accordion'

import '@img-comparison-slider/react';

import peopleSearch from './components/people-search'
import magnetNavigation from './components/magnet-navigation'
import tiekarttaNavigation from './components/tiekartta-navigation'
import mozaikManual from './components/mozaik-manual'
import mozaikAutomatic from './components/mozaik-automatic'
import archive from './components/archive'
import copyToClipboard from './components/clipboard'
import eventLive from './components/event-live'
import publicationOrderForm from './components/publication-order-form'
import navigation from './components/navigation'
import languageSelector from './components/language-selector'
import eventLiveStatus from './components/event-live-status'
import searchBar from './components/search-bar'
import tableOfContents from './components/table-of-contents'
import timeline from './components/timeline'
import videos from './components/videos'
import accessibilityKeyboardHelper from './components/accessibility-keyboard-helper'
import accessibilityPowerpress from './components/accessibility-powerpress'
import termsArchive from './components/terms-archive'
import seriouslySimplePodcasting from './components/seriously-simple-podcasting'
import readingList from './components/reading-list'
import readingListButton from './components/reading-list-button'
import { onIdle } from './utils';
import { toggler } from './components/toggler'
import sitraFacts from './components/sitra-facts'
import sitraToolkit from './components/sitra-toolkit'
import sitraFeedbackWall from './components/sitra-feedback-wall'

$(() => {
  // app.js is loaded at the end of body, so don't wait for document ready.
  const swiperObserver = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      // Wait until one entry is intersecting
      if (!entry.isIntersecting) {
        continue;
      }

      // Once one is intersecting, init all of them
      entries.forEach((entry) => {
        swiper(entry.target);
        swiperObserver.unobserve(entry.target);
      });
      break;
    }
  }, {rootMargin: '0px 0px 200px 0px'});

  for (const container of document.body.querySelectorAll('.js-swiper')) {
    swiperObserver.observe(container)
    // When idle, init anyways
    onIdle(() => swiper(container));
  }

  for (const accordion of document.body.querySelectorAll('.js-accordion-toggle')) {
    Accordion(accordion)
  }

  const iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
  if (iOS) {
    document.body.classList.add('device-ios');
  }
  if (window.matchMedia('only screen and (max-width: 760px)').matches) {
    document.body.classList.add('device-mobile');
  }

  document.querySelectorAll('.wp-block-sitra-accordion__toggle').forEach(toggler)

  tiekarttaNavigation();
  navigation();
  languageSelector();
  searchBar();
  eventLiveStatus(document);
  termDefinition();
  magnetNavigation();
  peopleSearch();
  timeline();
  seriouslySimplePodcasting();
  videos();
  tableOfContents();
  termsArchive();
  readingList();
  readingListButton();
  copyToClipboard();
  eventLive();
  publicationOrderForm();
  accessibilityKeyboardHelper();
  accessibilityPowerpress();
  sitraFacts();
  sitraToolkit();

  for (const container of document.querySelectorAll('.archive-js')) {
    archive(container);
  }

  for (const container of document.querySelectorAll('.mozaik-js')) {
    mozaikAutomatic(container);
  }

  for (const container of document.querySelectorAll('.js-mozaik-manual')) {
    mozaikManual(container);
  }

  // FacetWP loading indicator for työkalut post listing
  function showLoading() {
    const img = document.createElement('img');
    img.src = '/app/themes/sitra-v2/public/images/loading.svg'

    const loadingContainer = document.createElement('div')
    loadingContainer.classList.add('loading-container')
    loadingContainer.appendChild(img)

    const facetwpFilters = document.querySelector('.facetwp-filters');
    facetwpFilters.appendChild(facetwpFilters.firstChild, loadingContainer);

    document.addEventListener('facetwp-refresh', () => {
      if (window.FWP.loaded) {
        facetwpFilters.prepend(loadingContainer)
      }
    })

    window.FWP.hooks.addAction('facetwp/loaded', () => {
      loadingContainer.remove()
    }, 100)
  }

  // Add descriptions to facetwp filters
  function showFacetDescriptions() {
    const themesFacetTitle = document.querySelector(`#facet-group-themes .facetwp-filter__title`)
    const approachFacetTitle = document.querySelector(`#facet-group-lahestymistapa .facetwp-filter__title`)
    const themeDescription = document.createElement('p')
    const approachDescription = document.createElement('p')
    themeDescription.classList.add('facetwp-filter__description')
    approachDescription.classList.add('facetwp-filter__description')
    themesFacetTitle.parentNode.insertBefore(themeDescription, themesFacetTitle.nextSibling)
    approachFacetTitle.parentNode.insertBefore(approachDescription, approachFacetTitle.nextSibling)

    window.FWP.hooks.addAction('facetwp/loaded', () => {
      themeDescription.innerText = window.themeDescriptions[window.FWP.facets.themes[0]] ?? ''
      approachDescription.innerText = window.approachDescriptions[window.FWP.facets.lahestymistapa[0]] ?? ''
    }, 100)
  }

  if (window.FWP) {
    showLoading()
    showFacetDescriptions()
  }

  // Conditionally load Readspeaker on pages as needed
  if (document.querySelector('.rsbtn')) {
    const script = document.createElement('script')
    script.type = "text/javascript"

    if (window.objectL10n.current_language === 'en') {
      script.src = 'https://cdn-eu.readspeaker.com/script/13853/webReader/webReader.js?pids=wr&amp;lang=en_uk'
    } else if (window.objectL10n.current_language === 'sv') {
      script.src = 'https://cdn-eu.readspeaker.com/script/13853/webReader/webReader.js?pids=wr&amp;lang=sv_se'
    } else {
      script.src = 'https://cdn-eu.readspeaker.com/script/13853/webReader/webReader.js?pids=wr'
    }
    script.async = true
    script.id = "rs_req_Init"
    document.head.appendChild(script);
  }
})
